module.exports = __webpack_public_path__ + "img/5-1-b.9c3fb3db.jpg";